import { CustomBoxV2 } from "components";
import { TotalScansIcon } from "pages/internal-dashboard/icons";

export function TotalScans({ data, loading, percentages }: any) {
  return (
    <CustomBoxV2
      loading={loading}
      color="#2DD683"
      title="Total Scans"
      userCount={data?.total || 0}
      boxData={{
        label: "Scans",

        todayCount: data?.day || 0,
        weekCount: data?.week || 0,
        monthCount: data?.month || 0,
        yearCount: data?.year || 0,
        icon: TotalScansIcon,
      }}
      percentages={percentages}
    />
  );
}
